


import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DesignUpInteriors from "./interiordesign";
// import DesignUp from "./DesignPages/design";
import DesignUp from "./DesignPages/maindesign"

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/indu" element={<DesignUpInteriors />} />
        <Route path="/" element={<DesignUp />} />
      </Routes>
    </Router>
  );
}

export default App;